import React, { useState } from 'react';
import { useSwipeable } from 'react-swipeable';

export const GaleryMansionGrid = () => {
    const [selectedIndex, setSelectedIndex] = useState(null);

    const images = [
        {
            src: "assets/img/gallerie/photo-avant-apres-paysagiste.webp",
            caption: "Entretien espace vert défrichage et évacuation des encombrants"
        },
        {
            src: "assets/img/gallerie/photo-avant-apres-paysagiste-2.webp",
            caption: "Entretien espace vert défrichage et évacuation des encombrants"
        },
        {
            src: "assets/img/gallerie/elagage-arbre.webp",
            caption: "Élagage d'un arbre"
        },
        {
            src: "assets/img/gallerie/entretien-verger-immense.webp",
            caption: "Entretien d’un grand verger"
        },
        {
            src: "assets/img/gallerie/entretien-verger-immense-2.webp",
            caption: "Verger après entretien"
        },
        {
            src: "assets/img/gallerie/entretien-verger-immense-4.webp",
            caption: "Verger après entretien"
        },
        {
            src: "assets/img/gallerie/entretien-verger-immense-5.webp",
            caption: "Verger après entretien"
        },
        {
            src: "assets/img/gallerie/remise-en-etat-maison.webp",
            caption: "Remise en état de maison"
        },
        {
            src: "assets/img/gallerie/remise-en-etat-maison-2.webp",
            caption: "Remise en état de maison"
        },
        {
            src: "assets/img/gallerie/remise-en-etat-maison-3.webp",
            caption: "Remise en état de maison"
        },
        {
            src: "assets/img/cover-assainissement.webp",
            caption: "Travaux d'assainissement chez un particulier"
        },
    ];

    const openModal = (index) => {
        setSelectedIndex(index);
        document.getElementById("image_modal").showModal();
    };

    const closeModal = () => {
        document.getElementById("image_modal").close();
        setSelectedIndex(null);
    };

    const showPrev = () => {
        setSelectedIndex((prev) => (prev - 1 + images.length) % images.length);
    };

    const showNext = () => {
        setSelectedIndex((prev) => (prev + 1) % images.length);
    };

    const handleClickOutside = (e) => {
        const modalBox = document.querySelector("#image_modal .modal-box");
        if (modalBox && !modalBox.contains(e.target)) {
            closeModal();
        }
    };

    const swipeHandlers = useSwipeable({
        onSwipedLeft: () => showNext(),
        onSwipedRight: () => showPrev(),
        preventScrollOnSwipe: true,
        trackMouse: true
    });

    return (
        <div>
            <div className="columns-2 md:columns-3 gap-2 space-y-2 mb-3 py-4">
                {images.map((img, idx) => (
                    <img
                        key={idx}
                        src={img.src}
                        alt={`img-${idx}`}
                        className="w-full max-h-full object-cover rounded cursor-pointer"
                        onClick={() => openModal(idx)}
                        loading="lazy"
                    />
                ))}
            </div>

            <dialog id="image_modal" className="modal" onClick={handleClickOutside}>
                <div className="modal-box max-w-4xl w-full relative" {...swipeHandlers}>
                    <button
                        className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2 z-10"
                        onClick={closeModal}
                    >
                        ✕
                    </button>

                    {selectedIndex !== null && (
                        <div className="flex flex-col items-center gap-4">
                            <div className="flex justify-between w-full">
                                <button onClick={showPrev} className="btn btn-outline">
                                    ← Précédent
                                </button>
                                <button onClick={showNext} className="btn btn-outline">
                                    Suivant →
                                </button>
                            </div>

                            <img
                                src={images[selectedIndex].src}
                                alt={`image-${selectedIndex}`}
                                className="w-full h-auto rounded-lg object-cover"
                            />
                            <p className="text-center text-sm text-gray-600 mt-2">
                                {images[selectedIndex].caption}
                            </p>
                        </div>
                    )}
                </div>
            </dialog>
        </div>
    );
};
